// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Eaum","info":"PatientInfo_info__2fjd9"};